import { BlockDataForm } from '@plone/volto/components';
import PropTypes from 'prop-types';
import { schemaSummary } from '@arpav/components/ArpavTheme/Blocks/AnnouncementsSummary/schema';
import { useIntl } from 'react-intl';

const SummaryData = props => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = schemaSummary({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

SummaryData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default SummaryData;
